import { Box } from '@change-corgi/design-system-legacy/layout';

import { PetitionQRCodeDownload } from 'src/app/shared/components/qrcode';

import { usePetitionUrlQRCode } from './hooks/usePetitionUrlQRCode';

export function PetitionUrlQRCode() {
	const { data, actions } = usePetitionUrlQRCode();

	return (
		<Box mt={24}>
			<PetitionQRCodeDownload
				slugOrId={data.slugOrId}
				displaySize={data.displaySize}
				displayType={data.displayType}
				downloadType={data.downloadType}
				descriptionText={data.descriptionText}
				downloadLinkText={data.downloadLinkText}
				downloadFilename={data.downloadFilename}
				onDownload={actions.handleDownload}
			/>
		</Box>
	);
}
